<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path stroke="#000" d="M11 3.5h8.5a1 1 0 011 1v15a1 1 0 01-1 1H11M8.5 7.5l-5 4.5 5 4.5M16 12H4"/>
</svg>
